import { baseAPIRequest } from 'utilities/http';

import { baseURI } from './config';

async function getProductQuestions ({ sortOrder = 1, pageNumber = 1, pageSize = 3 } = {}) {

	try {

		const query = Object.entries({
			shortSku: window.shortSku,
			pageSize,
			pageNumber,
			sort: sortOrder
		})
			.map(([ key, value ]) => `${key}=${value}`)
			.join('&');

		const response = await baseAPIRequest({
			url: `${baseURI}/questions/?${encodeURI(query)}`,
			params: { method: 'GET' }
		});

		if (!response.isSuccess) {

			const [ error ] = response.errors;
			throw new Error(`Failed to get questions: ${error.message}`);

		}

		return response;

	} catch (error) {

		// eslint-disable-next-line no-console
		console.error(error.message);
		throw Error;

	}

}

export default getProductQuestions;
